<template>
  <v-toolbar-items>
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text>
          <v-icon color="gray-6">language</v-icon>
          <span class="ml-1">{{ currentLanguage.text }}</span>
          <v-icon color="gray-6" right small>keyboard_arrow_down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="lang in languages"
          :key="lang.value"
          @click="handleChangeLocale(lang.value)"
        >
          <v-list-item-title>{{ lang.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LanguageDropdownMenu',
  computed: {
    currentLanguage () {
      return this.languages.find(l => l.value === this.$i18n.locale)
    },

    languages () {
      const locales = this.$t('Components.LanguageDropdownMenu.languages')

      return this.$i18n.availableLocales.map(locale => {
        const abbreviation = locale.replace(/_/g, '-').toUpperCase()
        const localeTarget = locales.find(l => l.value === locale)
        const text = localeTarget ? localeTarget.text : null

        return {
          abbreviation,
          text,
          value: locale
        }
      })
    }
  },
  data () {
    return {
      namespace: 'Components.LanguageDropdownMenu'
    }
  },
  methods: {
    ...mapActions({
      changeLocale: 'locale/change'
    }),

    reloadPage () {
      location.reload()
    },

    handleChangeLocale (locale) {
      if (this.currentLanguage.value !== locale) {
        this.changeLocale(locale)
        this.reloadPage()
      }
    }
  }
}
</script>
